import { render, staticRenderFns } from "./MessageFiles.vue?vue&type=template&id=7c0dee9b&scoped=true&"
import script from "./MessageFiles.vue?vue&type=script&lang=js&"
export * from "./MessageFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0dee9b",
  null
  
)

export default component.exports